// 🔧 volunteer_report.js
// ✅ Purpose: Builds standardized execution reports for the Volunteer Engine
// ✅ Features:
// - Reports volunteer activities created
// - Reports volunteer time slots created
// - Returns Demo Report v2-compatible structured results
// - Keeps Volunteer Engine reporting consistent with other LGV engines
// - Fully block-commented for clarity and future devs

export const buildVolunteerReport = ({
  volunteerResults,
} = {}) => {
  const activities =
    volunteerResults?.activities || [];

  const timeSlots =
    volunteerResults?.timeSlots || [];

  return {
    success: true,

    created: {
      activities: activities.length,
      timeSlots: timeSlots.length,
    },

    summary: [
      `${activities.length} Volunteer Activities`,
      `${timeSlots.length} Volunteer Time Slots`,
    ].join(" • "),
  };
};